import _find from 'lodash/find';
import _head from 'lodash/head';
import _filter from 'lodash/filter';
import _curry from 'lodash/curry';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var isNotPrimaryOption = _curry(function (primaryOption, option) {
  return option.id !== primaryOption.id;
});
export var getMenuOptions = function getMenuOptions(options, primaryOptionId) {
  var primaryOption = getPrimaryOption(options, primaryOptionId) || EMPTY_OBJECT;
  var menuOptions = _filter(options, isNotPrimaryOption(primaryOption));
  return menuOptions;
};
export var getPrimaryOption = function getPrimaryOption(options, primaryOptionId) {
  var primaryOption = _find(options, {
    id: primaryOptionId
  });
  if (primaryOption) return primaryOption;
  return _head(options) || EMPTY_OBJECT;
};